import validate from "/builds/coingroup/financial-system/backoffice/node_modules/nuxt/dist/pages/runtime/validate.js";
import _10_45required_45auth_45global from "/builds/coingroup/financial-system/backoffice/app-modules/auth/middlewares/10.required-auth.global.ts";
import manifest_45route_45rule from "/builds/coingroup/financial-system/backoffice/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _10_45required_45auth_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}